import React, { useState } from 'react';
import cx from 'classnames';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexLayoutModifier } from '../flex/flex.constants';
import { ELSIcon } from '../els.components';
import { FlexItem } from '../flex/FlexItem.component';

export interface SimpleAccordionProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  onToggle?: (isExpanded: boolean) => void;
}

export const SimpleAccordion: React.FC<SimpleAccordionProps> = ({
    title,
    children,
    defaultExpanded = false,
    onToggle
  }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
    if (onToggle) {
      onToggle(newExpandedState);
    }
  };

  return (
    <div className={cx('c-nra-simple-accordion', { 'c-nra-simple-accordion--expanded': isExpanded })}>
      <button
        className="c-nra-simple-accordion__header u-els-debuttonize u-els-anchorize"
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
        type="button"
      >
        <FlexLayout modifiers={[FlexLayoutModifier.MIDDLE, FlexLayoutModifier.GUTTERS_1o2, FlexLayoutModifier.LEFT]}>
          <FlexItem>{title}</FlexItem>
          <FlexItem>
            <ELSIcon
              name="chevron-down"
              size="1x"
              customClass={
                cx('c-nra-simple-accordion__icon', { 'c-nra-simple-accordion__icon--rotated': isExpanded })
              }
            />
          </FlexItem>


        </FlexLayout>
      </button>
      {isExpanded && (
        <div className="c-nra-simple-accordion__content">
          {children}
        </div>
      )}
    </div>
  );
};
